import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const MeetingMinutes = () => {
  const navigate = useNavigate();
  const { clientId, meetingId } = useParams();
  const [copied, setCopied] = React.useState(false);

  const formatForWhatsApp = (minutes) => {
    let message = `*📋 ATA DA REUNIÃO*\n`;
    message += `*${minutes.client}* - ${minutes.date}\n`;
    message += `${'='.repeat(40)}\n\n`;

    minutes.sections.forEach((section, index) => {
      message += `*${section.title}*\n`;
      section.items.forEach(item => {
        message += `• ${item}\n`;
      });
      if (index < minutes.sections.length - 1) {
        message += `\n`;
      }
    });

    message += `\n${'='.repeat(40)}\n`;
    message += `_Gerado automaticamente pela BIANCA_`;

    return message;
  };

  const copyToClipboard = async () => {
    const formattedText = formatForWhatsApp(minutes);
    
    try {
      await navigator.clipboard.writeText(formattedText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Erro ao copiar:', err);
    }
  };

  const minutesData = {
    'camargo': {
      '13-11-2025': {
        date: '13/11/2025',
        client: 'Camargo',
        title: 'Ata da Reunião',
        sections: [
          {
            title: 'Melhorias Implementadas',
            items: [
              'Nova visualização de conversas',
              'Correções no kanban',
              'Aba de documentação integrada',
              'Correções de bugs (horário, script, qualificação)',
              'Novos filtros e opções de responsável'
            ]
          },
          {
            title: 'Pendências',
            items: [
              'Script de cadência de follow up em texto'
            ]
          },
          {
            title: 'Campanha - Decisões',
            items: [
              'AD 2 (Fachadas) apresentou melhor performance',
              'Custo por agendamento 63% mais barato',
              'Taxa de agendamento 5x superior',
              'Decisão: Concentrar verba total no AD 2'
            ]
          }
        ]
      },
      '20-11-2025': {
        date: '20/11/2025',
        client: 'Camargo',
        title: 'Ata da Reunião',
        sections: [
          {
            title: 'Melhorias Implementadas - Documentos',
            items: [
              'Adição de formulário para contrato',
              'Adição de contrato gerado dinamicamente',
              'Adição da lista de documentos necessários',
              'Adição de geração de Processo com junção de PDFs',
              'Adição de lead fora da Bianca'
            ]
          },
          {
            title: 'Melhorias Implementadas - Sistema',
            items: [
              'FUP adicionado na marra',
              'Criação de um MVP de Clone da Vapi'
            ]
          },
          {
            title: 'Campanha - Teste A/B (3 anúncios)',
            items: [
              'AD 1 (Campeão Adaptado): CPL R$ 8,52 | Taxa 4% | CPA R$ 191,70',
              'AD 2 (Fachadas): CPL R$ 13,81 | Taxa 19% | CPA R$ 72,82',
              'AD 3 (Campeões Intercalados): CPL R$ 13,57 | Taxa 18% | CPA R$ 75,43',
              'Decisão: Rodar mais uma semana - resultados muito próximos',
              'Mais dados necessários para decisão definitiva'
            ]
          }
        ]
      },
      '27-11-2025': {
        date: '27/11/2025',
        client: 'Camargo',
        title: 'Ata da Reunião',
        sections: [
          {
            title: 'Melhorias Publicadas',
            items: [
              '\\n sendo enviados no FUP corrigido',
              'Removido o FUP1, começando direto pelo 2',
              'Corrigido o erro de qualificação e fuga do script',
              'Melhorada lógica de envio pro WhatsApp',
              'Corrigido bug de 2 agendamentos no mesmo horário',
              'Ocultado dados do contrato',
              'Botão de documento não necessário',
              'Separação de documentos do processo',
              'Termo de horários e bônus separados',
              'Opção de remover arquivo upado',
              'Folha de pagamento e IR aceitam múltiplos arquivos',
              'Renomear arquivos individualmente',
              'Certidões de dependentes com botão "não precisa"'
            ]
          },
          {
            title: 'Em Finalização',
            items: [
              'Conexão com Google Drive',
              'Atualização no Dashboard',
              'Ponte SDR',
              'Atualizações em Calendário'
            ]
          },
          {
            title: 'Campanha - Teste A/B (3 anúncios)',
            items: [
              'AD 1 (Campeão Adaptado): CPL R$ 8,52 | Taxa 4% | CPA R$ 191,70',
              'AD 2 (Fachadas): CPL R$ 15,13 | Taxa 19% | CPA R$ 80,04',
              'AD 3 (Campeões Intercalados): CPL R$ 10,27 | Taxa 19% | CPA R$ 53,13 ⭐',
              'CPL últimos 7 dias: R$ 8,69 e caindo',
              'Decisão: Aumentar verba AD 3, diminuir AD 2 (tendência de pausa)'
            ]
          }
        ]
      },
      '03-12-2025': {
        date: '03/12/2025',
        client: 'Camargo',
        title: 'Ata da Reunião',
        sections: [
          {
            title: 'Melhorias Publicadas',
            items: [
              'Implementação da Ponte SDR - sistema de conexão entre SDR e Lead no pós agendamento',
              'Novo Dashboard com métricas atualizadas e visualização otimizada',
              'Ajustes em documentos'
            ]
          },
          {
            title: 'Campanha - Teste A/B (2 anúncios)',
            items: [
              'AD 2 (Fachadas): CPL R$ 20,22 | Taxa 14% | CPA R$ 144,89',
              'AD 3 (Campeões Intercalados): CPL R$ 10,84 | Taxa 7% | CPA R$ 149,94',
              'AD 3 tem CPL 46% mais barato, porém AD 2 converte 2x mais',
              'CPAs muito próximos entre os dois anúncios',
              'Decisão: Voltar para a verba da semana passada'
            ]
          }
        ]
      },
      '12-12-2025': {
        date: '12/12/2025',
        client: 'Camargo',
        title: 'Ata da Reunião',
        sections: [
          {
            title: 'Melhorias Publicadas',
            items: [
              'Proposta',
              'Conexão com drive'
            ]
          },
          {
            title: 'Campanha - Resultados (2 anúncios)',
            items: [
              'AD 2 (Fachadas): CPL R$ 15,26 | Taxa 13.3% | CPA R$ 114,43',
              'AD 3 (Campeões Intercalados): CPL R$ 12,70 | Taxa 11.1% | CPA R$ 114,29',
              'CPAs muito próximos entre os dois anúncios',
              'Decisão: Alterar verba para valor de 3 semanas atrás e aguardar 2 semanas para análise'
            ]
          }
        ]
      },
      '26-12-2025': {
        date: '26/12/2025',
        client: 'Camargo',
        title: 'Ata da Reunião',
        sections: [
          {
            title: 'Melhorias Publicadas',
            items: [
              'Integração com Google Calendar implementada',
              'Ajustes para colocar proposta em produção',
              'Adicionado nova Business Manager (BM)'
            ]
          },
          {
            title: 'Campanha - Resultados (2 anúncios)',
            items: [
              'AD 1 (Campeão Adaptado): CPL R$ 26,73 | Taxa 7,7% | CPA R$ 361,54',
              'AD 2 (Fachadas): CPL R$ 16,50 | Taxa 6% | CPA R$ 275,21',
              'AD 2 apresenta CPL 38% mais barato e CPA 24% menor',
              'AD 1 tem taxa de conversão 28% maior'
            ]
          },
          {
            title: 'Análise Profunda',
            items: [
              'CPL: AD 2 tem CPL 38% mais barato (R$ 16,50 vs R$ 26,73) - Vencedor: AD 2',
              'Taxa de Conversão: AD 1 converte 28% mais leads em agendamentos (7,7% vs 6%) - Vencedor: AD 1',
              'CPA: AD 2 tem custo por agendamento 24% menor (R$ 275,21 vs R$ 361,54) - Vencedor: AD 2',
              'Conclusão: Apesar do AD 1 ter melhor taxa de conversão, o AD 2 apresenta melhor eficiência de custo no geral'
            ]
          },
          {
            title: 'Decisão',
            items: [
              'Manter configuração atual por pelo menos mais uma semana',
              'Período de Natal causa aumento no leilão de anúncios',
              'Configuração atual é a mesma da semana campeã',
              'Aguardar estabilização pós-feriado para tomar decisões'
            ]
          }
        ]
      }
    },
    'paradise': {
      'start': {
        date: '19/12/2025',
        client: 'Paradiso Wellness Club',
        title: 'Ata da Reunião de Start',
        sections: [
          {
            title: 'Implementação Realizada',
            items: [
              'Desenvolvemos o Novo Funil da Paradiso Wellness Club',
              'Novo Anúncio feito com IA',
              'Nova Plataforma para criação de mais anúncios',
              'Analisamos as campanhas antigas do Google e Meta',
              'Deixamos criado no rascunho nossa campanha de Lead Forms com a Api de conversões configurada',
              'Criamos o Script da Bianca com objetivo de agendamento de reunião',
              'Conectamos dashboard para puxar todos os dados da campanha',
              'Configuramos a plataforma'
            ]
          },
          {
            title: 'Pendências',
            items: [
              'Temos um documento com todo o processo de migração da Bianca',
              'Peço que revisem o documento para definirmos priorização de tarefas a serem desenvolvidas',
              'Objetivo: deixar o sistema do jeito que vocês esperam'
            ]
          },
          {
            title: 'Acessos',
            items: [
              'Definir emails e telefones para acesso à plataforma'
            ]
          },
          {
            title: 'Próximos Passos',
            items: [
              'Ativar a campanha',
              'Marcar check-in semanal: sugestão quarta 17h'
            ]
          }
        ]
      }
    },
    'apolar': {
      '28-11-2025': {
        date: '28/11/2025',
        client: 'Apolar',
        title: 'Ata da Reunião',
        sections: [
          {
            title: 'Introdução',
            items: [
              'Correção do bug do captcha',
              'Ponte SDR',
              'Adição de campo de agendamento no Sales Force'
            ]
          },
          {
            title: 'Melhorias no Sistema',
            items: [
              'Correção de bugs na extração de lista - tudo pronto para iniciar a extração. Link enviado para o Marcelo fazer o pagamento dos créditos',
              'Adicionado o campo de data do agendamento no Sales Force',
              'Criação de Sistema de conexão entre SDR e o Lead no pós agendamento (finalizando o desenvolvimento)'
            ]
          }
        ]
      },
      '05-12-2025': {
        date: '05/12/2025',
        client: 'Apolar',
        title: 'Ata da Reunião',
        sections: [
          {
            title: 'Avanços da Semana',
            items: [
              'Avanço na Ponte SDR',
              'Lista de imobiliárias sendo rodada'
            ]
          }
        ]
      }
    }
  };

  const minutes = minutesData[clientId]?.[meetingId];

  if (!minutes) {
    return (
      <Container>
        <SlideTitle>Ata não encontrada</SlideTitle>
      </Container>
    );
  }

  return (
    <Container>
      <BackButton onClick={() => navigate(`/clientes/${clientId}/${meetingId}`)}>
        ← Voltar para Apresentação
      </BackButton>

      <Header>
        <Title>{minutes.title}</Title>
        <Date>{minutes.client} - {minutes.date}</Date>
        <WhatsAppButton onClick={copyToClipboard}>
          {copied ? '✓ Copiado!' : '📱 Copiar para WhatsApp'}
        </WhatsAppButton>
      </Header>

      <Content>
        <SummarySections>
          {minutes.sections.map((section, index) => (
            <SummarySection key={index}>
              <SectionTitle>{section.title}</SectionTitle>
              <SectionItems>
                {section.items.map((item, itemIndex) => (
                  <SectionItem key={itemIndex}>
                    <ItemBullet>•</ItemBullet>
                    <ItemText>{item}</ItemText>
                  </SectionItem>
                ))}
              </SectionItems>
            </SummarySection>
          ))}
        </SummarySections>
      </Content>
    </Container>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
  padding: 4rem 2rem;
`;

const BackButton = styled.button`
  background: rgba(100, 182, 255, 0.1);
  border: 1px solid rgba(100, 182, 255, 0.3);
  color: #64B6FF;
  font-family: 'Orbitron', sans-serif;
  font-size: 0.9rem;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 2rem;

  &:hover {
    background: rgba(100, 182, 255, 0.2);
    border-color: rgba(100, 182, 255, 0.6);
    transform: translateX(-4px);
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 4rem;
  animation: ${fadeIn} 0.8s ease;
`;

const Title = styled.h1`
  font-family: 'Orbitron', sans-serif;
  font-size: 3rem;
  font-weight: 600;
  background: linear-gradient(135deg, #64B6FF 0%, #34CFEB 50%, #00FFFF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1rem;
  letter-spacing: 4px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Date = styled.p`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.2rem;
  color: rgba(100, 182, 255, 0.7);
  letter-spacing: 2px;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const WhatsAppButton = styled.button`
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border: none;
  color: white;
  font-family: 'Orbitron', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 1rem 2rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
  letter-spacing: 1px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.875rem 1.5rem;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  animation: ${fadeIn} 0.8s ease 0.2s both;
`;

const SlideTitle = styled.h2`
  font-family: 'Orbitron', sans-serif;
  font-size: 3rem;
  font-weight: 600;
  background: linear-gradient(135deg, #64B6FF 0%, #34CFEB 50%, #00FFFF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-align: center;
  letter-spacing: 3px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const SummarySections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`;

const SummarySection = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(100, 182, 255, 0.2);
  border-radius: 12px;
  padding: 2rem;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(100, 182, 255, 0.4);
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(100, 182, 255, 0.1);
  }
`;

const SectionTitle = styled.h3`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.5rem;
  color: #64B6FF;
  margin-bottom: 1.5rem;
  letter-spacing: 2px;
`;

const SectionItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const SectionItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`;

const ItemBullet = styled.div`
  color: #64B6FF;
  font-size: 1.5rem;
  line-height: 1;
  margin-top: 0.2rem;
`;

const ItemText = styled.p`
  font-family: 'Orbitron', sans-serif;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  flex: 1;
`;

export default MeetingMinutes;
